import React, { useContext, useEffect, useState } from 'react';
import { Context } from '../../store/AppContext';
import RenderPatenteTabla from './RenderPatenteTabla';
import ModalPatenteSeleccionada from './ModalPatenteSeleccionada';

const MESES = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
];

const generarOpcionesMes = () => {
  const opciones = [];
  const ahora = new Date();
  const cursor = new Date(ahora.getFullYear(), ahora.getMonth(), 1);
  const inicio = new Date(2023, 0, 1);

  while (cursor >= inicio) {
    opciones.push({
      year: cursor.getFullYear(),
      month: cursor.getMonth() + 1,
      label: `${MESES[cursor.getMonth()]} ${cursor.getFullYear()}`,
    });
    cursor.setMonth(cursor.getMonth() - 1);
  }

  return opciones;
};

const PatentesPorMes = ({ onRegresar }) => {
  const { store, actions } = useContext(Context);
  const [modalPatente, setModalPatente] = useState(null);
  const ahora = new Date();
  const [year, setYear] = useState(ahora.getFullYear());
  const [month, setMonth] = useState(ahora.getMonth() + 1);
  const onVista = 'PorMes';
  const opcionesMes = generarOpcionesMes();
  const patentes = store.patentes || [];
  const mesSeleccionado = opcionesMes.find(
    (opcion) => opcion.year === year && opcion.month === month
  );

  useEffect(() => {
    actions.getPatentesPorFechaCreacion(year, month);
  }, [year, month]);

  const handleCambioMes = (event) => {
    const [nuevoYear, nuevoMonth] = event.target.value.split('-').map(Number);
    setYear(nuevoYear);
    setMonth(nuevoMonth);
  };

  const abrirModal = (patente) => {
    actions.getPatente(patente.id);
    setTimeout(() => {
      setModalPatente(store.patente);
    }, 700);
  };

  const actualizarModal = (patenteId) => {
    actions.getPatente(patenteId);
    setTimeout(() => {
      setModalPatente(store.patente);
    }, 700);
  };

  const cerrarModal = () => {
    setModalPatente(null);
  };

  return (
    <div className="grid-container">
      <div className="grid-x grid-padding-x">
        <div className="cell">
          <button className="button" onClick={onRegresar}>Regresar</button>
          <h2>Patentes creadas por mes</h2>
          <div className="grid-x grid-padding-x align-middle" style={{ marginBottom: '15px' }}>
            <div className="cell small-12 medium-4">
              <label>
                Mes de creación
                <select
                  value={`${year}-${month}`}
                  onChange={handleCambioMes}
                >
                  {opcionesMes.map((opcion) => (
                    <option
                      key={`${opcion.year}-${opcion.month}`}
                      value={`${opcion.year}-${opcion.month}`}
                    >
                      {opcion.label}
                    </option>
                  ))}
                </select>
              </label>
            </div>
          </div>
          <h5>
            {patentes.length} patente{patentes.length === 1 ? '' : 's'} en {mesSeleccionado ? mesSeleccionado.label : ''}
          </h5>
          {patentes.length > 0 ? (
            <RenderPatenteTabla
              patentes={patentes}
              onClickFila={abrirModal}
              mostrarFechaCreacion
              mostrarFechaTramitacion
            />
          ) : (
            <div className="callout warning">
              <h5>No hay patentes creadas en este mes</h5>
              <p>Selecciona otro mes para consultar.</p>
            </div>
          )}
          <ModalPatenteSeleccionada
            patente={modalPatente}
            onClose={cerrarModal}
            onUpdate={actualizarModal}
            onVista={onVista}
            busqueda={{ year, month }}
          />
        </div>
      </div>
    </div>
  );
};

export default PatentesPorMes;
